import React from 'react';
import { Play, Stop, ListBullets, DiamondsFour, GitFork, GitMerge, ArrowsIn } from '@phosphor-icons/react';

const palette = [
  { type: 'start',     label: 'Start',      icon: Play,           color: 'emerald', desc: 'Entry point' },
  { type: 'end',       label: 'End',         icon: Stop,           color: 'red',     desc: 'Terminal' },
  { type: 'task',      label: 'Task',        icon: ListBullets,    color: 'brand',   desc: 'Action step' },
  { type: 'exclusive', label: 'Exclusive',   icon: DiamondsFour,   color: 'amber',   desc: 'If/else branch' },
  { type: 'parallel',  label: 'Parallel',    icon: GitFork,        color: 'violet',  desc: 'Split into parallel' },
  { type: 'sync',      label: 'Sync',        icon: ArrowsIn,       color: 'cyan',    desc: 'Wait for all' },
  { type: 'merge',     label: 'Merge',       icon: GitMerge,       color: 'pink',    desc: 'Any branch continues' },
];

export default function NodePalette() {
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="space-y-1.5">
      <p className="text-[10px] uppercase tracking-wider text-zinc-500 font-semibold px-1 mb-2">Drag to Canvas</p>
      {palette.map(item => {
        const Icon = item.icon;
        return (
          <div
            key={item.type}
            draggable
            onDragStart={(e) => onDragStart(e, item.type)}
            className={`flex items-center gap-2.5 px-2.5 py-2 rounded-lg cursor-grab active:cursor-grabbing border border-transparent hover:border-${item.color}-500/30 hover:bg-${item.color}-500/5 transition-all group`}
            data-testid={`palette-${item.type}`}
          >
            <div className={`w-7 h-7 rounded flex items-center justify-center bg-${item.color}-500/15`}>
              <Icon weight="bold" className={`w-4 h-4 text-${item.color}-400`} />
            </div>
            <div>
              <p className="text-xs font-medium text-zinc-200 group-hover:text-white">{item.label}</p>
              <p className="text-[10px] text-zinc-600">{item.desc}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
